import React, {Component} from "react";
import {SortableTableHeader} from "../../components/table/sortable-table-header";

export default class ContractsMainTableHeader extends Component {

  static Layout = [
    { column: "constractStartDate", width: 2, name: "Contract Start Date" },
    { column: "constractEndDate", width: 2, name: "Contract End Date" },
    { column: "supplierName", width: 2, name: "Supplier" },
    { column: "utilityAlias", width: 2, name: "Utility" },
    { column: "tradedCost", width: 2, },
    { column: "exposedCost", width: 2, },
    { column: "markCostPerUnit", width: 2, name: "Mark Cost (Live)"},
    { column: "empty", width: 3 }
  ];

  render() {
    return (
        <SortableTableHeader column={this.props.column} direction={this.props.direction} onChangeSort={this.props.onChangeSort} headings={ContractsMainTableHeader.Layout}/>
    )
  }
}